import { Pipe, PipeTransform } from '@angular/core';
import parsePhoneNumberFromString from 'libphonenumber-js/min';
import { CountryCode } from 'libphonenumber-js/types';

@Pipe({
  name: 'formattedPhoneNumber',
  standalone: true
})
export class FormattedPhoneNumberPipe implements PipeTransform {
  transform(value: string, countryCode: string): string {
    if (!value || !countryCode) {
      return '';
    }

    try {
      const phoneNumber = parsePhoneNumberFromString(value, countryCode as CountryCode);
      if (phoneNumber) {
        return phoneNumber.formatInternational();
      }
    } catch (error) {
      return value;
    }

    return value;
  }
}
